App.initSave4Later = () ->

  App.Model.LaterItem = Backbone.Model.extend({ idAttribute: 'ean' })

  App.Collection.LaterItemsCollection = Backbone.Collection.extend({ model: App.Model.LaterItem })

  App.View.LaterItem = Backbone.View.extend({
    tagName: 'li'
    className: 'row 25%'
    template: _.template($('#later-item-template').html())
    events: {
      'click .add2cart-item': 'add2cart'
      'click .remove-item': 'remove_item'
    }
    initialize: ->
      # On init, render
      @render()
      # If this models contents change, we re-render
      @model.on 'change', (->
        @render()
        return
      ), this
      return
    render: ->
      # Render the view with the template
      @$el.html @template(@model.toJSON())
      this
    add2cart: ->
      item = @model.toJSON()
      $.ajax({
        url: '/save4later/move/' + item['ean']
        success: (data) ->
          App.save4laterItems.remove(App.save4laterItems.where({ ean: item['ean'] }))
          if App.save4laterItems.size() == 0
            $('#later-items-text').addClass 'hidden'
            $('#later-items').addClass 'hidden'
          else
            App.viewSave4Later.render()
          if !App.cart || !App.cartItems
            App.cartItems = new (App.Collection.Items)
            App.cart = new (App.View.ShoppingCart)
          if !App.cartItems.get(item.ean)
            item.quantity = 1
            model = new (App.Model.Item)(item)
            App.cartItems.add model
            App.cart.render()
          if(App.cartItems.size() > 0)
            $('#cart-items').show()
            $('.cart-empty').addClass 'hidden'
            $('.cart-header').removeClass 'hidden'
            $('.cart-footer').removeClass 'hidden'
            $('.cart-footer').show()
            $('.cart-header').show()
            if data.user
              #App.initUser data.user, true
              #$('#checkout').show()
            else
              $('#login').removeClass 'hidden'
            return
      })
    remove_item: ->
      item = @model.toJSON()
      $.ajax({
        url: '/save4later/remove/' + item['ean']
        dataType: 'json',
        success: (data) ->
          App.save4laterItems.remove(App.save4laterItems.where({ ean: item['ean'] }))
          if App.save4laterItems.size() == 0
            $('#later-items-text').addClass 'hidden'
            $('#later-items').addClass 'hidden'
          else
            App.viewSave4Later.render()
      })
      return
  })

  App.View.LaterItems = Backbone.View.extend({
    el: '#later-items'
    initialize: ->
      # make a reference to the collection this view dances with
      @collection = App.save4laterItems
      @render()
      return
    render: ->
      # Empty the view
      @$el.html ''
      container = document.createDocumentFragment()
      # Loop through the collection
      @collection.each ((item) ->
        # Render each item model into this List view
        newItem = new (App.View.LaterItem)({ model: item })
        container.appendChild newItem.render().el
        # Pass this list views context
        return
      ), this
      @$el.append container
      return
  })